import { useTranslation } from 'react-i18next'
import Chip from '@mui/material/Chip'
import PropTypes from 'prop-types'

import { QUOTE_SOURCE_TYPES } from '@/common/utils'

const QuoteSourceChip = ({ quoteSource }) => {
    const { t } = useTranslation()

    return (
        <Chip
            label={t(QUOTE_SOURCE_TYPES[quoteSource])}
            size="small"
            sx={{ textTransform: 'uppercase', fontSize: '11px', userSelect: 'none' }}
            title={t(QUOTE_SOURCE_TYPES[quoteSource])}
        />
    )
}

QuoteSourceChip.propTypes = {
    quoteSource: PropTypes.oneOf(['Internal', 'WebStore']).isRequired,
}

export default QuoteSourceChip
